/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Get_Started_FreeInputs */

const en_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started Free`)
};

const de_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten`)
};

const fr_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer gratuitement`)
};

const es_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar gratis`)
};

const it_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis`)
};

const nl_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis beginnen`)
};

const pl_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo`)
};

const fi_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ilmaiseksi`)
};

const da_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom gratis i gang`)
};

const sv_landing_cta_get_started_free = /** @type {(inputs: Landing_Cta_Get_Started_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång gratis`)
};

/**
* | output |
* | --- |
* | "Get Started Free" |
*
* @param {Landing_Cta_Get_Started_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cta_get_started_free = /** @type {((inputs?: Landing_Cta_Get_Started_FreeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Get_Started_FreeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cta_get_started_free(inputs)
	if (locale === "fr") return fr_landing_cta_get_started_free(inputs)
	if (locale === "es") return es_landing_cta_get_started_free(inputs)
	if (locale === "it") return it_landing_cta_get_started_free(inputs)
	if (locale === "nl") return nl_landing_cta_get_started_free(inputs)
	if (locale === "pl") return pl_landing_cta_get_started_free(inputs)
	if (locale === "fi") return fi_landing_cta_get_started_free(inputs)
	if (locale === "da") return da_landing_cta_get_started_free(inputs)
	if (locale === "sv") return sv_landing_cta_get_started_free(inputs)
	return en_landing_cta_get_started_free(inputs)
});